export const OrgUserListTestIds = {
  orgUserList: 'org_user_list',
  orgHeader: 'org_header',
  orgTitle: 'org_title',
  filterRow: 'filter_row',
  filterLabel: 'filter_label',
  filterControls: 'filter_controls',
  userFilterDropdown: 'user_filter_dropdown',
  userFilterSelect: 'user_filter_select',
  tableSettingsComponent: 'table_settings_component',
  orgUserTable: 'org_user_table',
  userInputField: 'user_input_field',
  userInput: 'user_input',
  usernameAutocompleteContainer: 'username_autocomplete_container',
  messageInputField: 'message_input_field',
  messageInput: 'message_input',
  cancelSysNotify: 'cancel_sys_notify',
  submitSysNotify: 'submit_sys_notify',
  spinnerBackdrop: 'spinner_backdrop',
  sysNotifyButton: 'sys_notify_button',
  userSearch: 'user-search',
  filterAllUsers: 'filter_all_users',
  userTable: 'user_table',
  filterDeactivatedUsers: 'filter_deactivated_users'
} as const;
